import React, { useState, createContext } from 'react';
import { checkMaintenance } from '../../api/api';
import { useApi } from '../../hooks/use-api';

export const MaintenanceContext = createContext();

const MaintenanceProvider = ({ children }) => {
  const [maintenance, setMaintenance] = useState({});

  useApi({
    requestFn: checkMaintenance,
    onSuccess: (response) => {
      setMaintenance(response);
    },
  });

  return (
    <MaintenanceContext.Provider
      value={{
        maintenanceData: maintenance,
      }}
    >
      {children}
    </MaintenanceContext.Provider>
  );
};

export default MaintenanceProvider;
